import { FC, FormEventHandler, ReactNode } from "react";
import { Method } from "axios";

export interface IForm {
  action: string;
  method?: Method;
  onSubmit: FormEventHandler<HTMLFormElement>;
  children: ReactNode;
  className?: string;
  dataTestId?: string;
}

const Form: FC<IForm> = ({ action, method = "post", onSubmit, className, children, dataTestId }) => (
  <form data-component="Form" data-testid={dataTestId} method={method} action={action} onSubmit={onSubmit} className={className}>
    { children }
  </form>
);

Form.displayName = "Form";

export default Form;
